import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import type { RootState } from '/business/shared/state/store';

type AirportCanonicalNameProps = {
  airportCode?: string | null;
};

function AirportCanonicalName({ airportCode = null }: AirportCanonicalNameProps) {
  const airports = useSelector((state: RootState) => state.airports?.items) || null;

  const baseI18nKey = 'AirportCanonicalName';
  const baseArray = airports;
  const { t } = useTranslation();
  if (!baseArray || !Array.isArray(baseArray) || baseArray.length <= 0) {
    return <>{t(`shared:${baseI18nKey}.airportsNotLoaded`, 'Airports not loaded')}</>;
  }
  const airport = baseArray.find(({ code }) => code === airportCode);
  if (!airport) {
    return <>{t(`shared:${baseI18nKey}.cannotFindAirport`, 'Cannot find airport')}</>;
  }
  return <>{airport.name}</>;
}

export default AirportCanonicalName;
